module.exports = __webpack_public_path__ + "img/word2.089c05e6.png";